import ConfirmDialog, { type ConfirmDialogProps } from "@galaxy-io/dls/modal/ConfirmDialog";
import { useEffect, useState } from "react";

/** Shared request error handling; DLS owns pending, dismissal and focus behavior. */
export function ConfirmAction({
  onConfirm,
  ...props
}: Omit<ConfirmDialogProps, "onConfirm" | "error"> & { onConfirm: () => Promise<unknown> }) {
  const [error, setError] = useState<string>();
  useEffect(() => {
    if (!props.isOpen) setError(undefined);
  }, [props.isOpen]);
  return (
    <ConfirmDialog
      {...props}
      error={error}
      onConfirm={async () => {
        setError(undefined);
        try {
          await onConfirm();
        } catch (reason) {
          setError(reason instanceof Error ? reason.message : "The action failed. Try again.");
          throw reason;
        }
      }}
    />
  );
}
